/*
 * @Author: mxh
 * @Date: 2021-11-30 15:53:58
 * @LastEditTime: 2022-01-20 13:58:15
 * @LastEditors: mxh
 * @Description: 侧边栏菜单
 * @status:
 */

import React, {useEffect, useState} from 'react';
import {Layout, Menu} from 'antd';
import './index.scoped.less';
import {Link, withRouter} from 'react-router-dom';
import {routes} from '@/router/index';
import store from '@/store';
const {Sider} = Layout;
const {SubMenu} = Menu;

const SideBar: React.FC = (props: any) => {
    const [collapsed, setCollapsed] = useState(false); // 控制菜单展开还是收起
    const [openKeys, setOpenKeys] = useState([]); // 打开的子菜单
    const [defaultRoute, setDefaultRoute] = useState(['1']); // 默认选中
    const [num, setNum] = useState(0);

    store.subscribe(() => {
        setNum(store.getState().reportNum);
    });

    /**
     * @description: 菜单整体的展开与收缩
     * @param {boolean} collapsed
     * @return {*}
     */
    const onCollapse = (collapsed: boolean) => {
        setCollapsed(collapsed);
    };
    /**
     * @description: 菜单子菜单打开状态改变
     * @param {*} data
     * @return {*}
     */
    const subMenuOpenChange = data => {
        if (data.length > 0) {
            setOpenKeys([data[data.length - 1]]);
        } else {
            setOpenKeys([]);
        }
    };

    /**
     * @description: 菜单项选中
     * @param {*} data
     * @return {*}
     */
    const onSelectChange = data => {
        setDefaultRoute(data.key);
        if (data.keyPath.length === 1) {
            setOpenKeys([]);
        }
    };

    props.history.listen(route => {
        setDefaultRoute([route.pathname]);
    });

    useEffect(() => {
        const {location} = props;
        routes.forEach(item => {
            if (item.children) {
                item.children.forEach(item1 => {
                    if (item.path + '/' + item1.path === location.pathname) {
                        setOpenKeys([item.key]);
                        setDefaultRoute(item1.path);
                    }
                });
            } else {
                if (item.path === location.pathname) {
                    setDefaultRoute(item.path);
                }
            }
        });
    }, []);

    return (
        <Sider id={'sideBar'} collapsible collapsed={collapsed} onCollapse={onCollapse}>
            <div className='logo'>
                <svg
                    style={{width: 'auto', height: collapsed ? '55px' : '100px'}}
                    className='icon'
                    viewBox='0 0 1986 1024'
                    version='1.1'
                    xmlns='http://www.w3.org/2000/svg'
                    p-id='2643'
                    width='200'
                    height='200'>
                    <path
                        d='M1888.81441 410.493503c-52.885118 0-96.078143 42.470633-97.342328 95.747046-1.504983 64.187544-44.803357 107.877213-108.358807 109.367146-50.778141 1.188937-93.399272 43.087676-94.813957 93.308973-1.504983 55.684387 37.624586 99.328907 92.932727 103.211764 48.987211 3.491562 94.588209-35.186513 100.638243-85.543258 1.219037-10.173688 0.90299-20.588173 2.67887-30.641463 9.255648-52.478772 50.296546-87.003092 105.348841-89.185319 44.938805-1.760831 80.953059-29.392326 92.737079-71.140567 17.683555-62.833058-29.03113-125.109273-93.820668-125.124322zM1417.34825 823.069662c-63.720999-1.309336-107.756814-46.473888-107.771864-110.736682 0-133.943526 0-55.488739-0.150498-189.387115a117.840203 117.840203 0 0 0-2.438074-25.584718c-11.678671-51.319935-56.090733-82.458042-108.524355-76.528408-47.316679 5.342691-83.662029 48.008972-83.752328 98.651664-0.105349 67.950002-0.481595 128.07409 0.346146 196.340139a103.377312 103.377312 0 0 0 8.412857 40.303456c17.653456 39.129569 49.318307 57.430168 91.653492 58.694354 51.861729 1.504983 93.308973 38.452327 101.270335 89.922761 1.77588 11.407774 1.339435 23.176745 3.356113 34.52432 8.819203 49.453756 55.579038 85.603458 103.151565 80.260766 53.697809-6.019934 92.436083-50.176148 89.862561-102.338873-2.543422-51.906879-44.336812-93.068176-95.41595-94.121664z'
                        fill='#ffffff'
                        p-id='2644'></path>
                    <path
                        d='M1448.516457 418.846161a98.230269 98.230269 0 0 0-97.432628 98.004521c-0.150498 33.847077 0 63.058806 0 96.890834 0 33.531031-0.120399 67.047012 0 100.562993 0.240797 54.405151 43.238174 97.688475 97.131631 97.959372 55.368341 0.285947 99.223558-42.350234 99.539604-97.658376 0.376246-67.724255 0.361196-130.737911 0-198.432066-0.331096-54.344952-44.878606-97.643325-99.238607-97.327278zM1182.089239 196.951403c51.079138-1.053488 92.872528-42.229835 95.41595-94.001265 2.573522-52.237975-36.119602-96.31894-89.862561-102.429173-47.572526-5.327641-94.332362 30.822061-103.136515 80.275816-2.016678 11.347575-1.504983 23.116546-3.371163 34.524321-8.036612 51.470433-49.408606 88.372627-101.270335 89.92276-42.320134 1.264186-74.000036 19.564785-91.653491 58.694354a103.60306 103.60306 0 0 0-8.412858 40.303456c-0.827741 68.266049-0.376246 136.547147-0.376245 204.813196v203.834956c0 50.642693 36.420599 93.308973 83.737278 98.666714 52.433623 5.914585 96.860734-25.223522 108.524355-76.543457a116.907113 116.907113 0 0 0 2.438074-25.584719q0.255847-200.840039 0.150498-401.695128c0.090299-64.368142 44.111064-109.517645 107.817013-110.781831zM547.302276 626.217828a106.552827 106.552827 0 0 0-41.522493-10.203787c-61.222726-1.77588-106.086282-45.811696-107.576216-107.485917-1.354485-55.684387-44.020765-98.305518-98.200169-98.109871-52.794819 0.180598-95.852395 43.042526-96.770435 96.31894-1.083588 62.953457-45.4505 107.666515-107.952462 108.810303-51.169437 0.93309-93.971166 43.072626-95.235351 93.820667-1.384585 55.232892 37.880433 98.817212 92.481232 102.68502 49.814952 3.521661 95.762096-35.668107 101.195086-87.153591 2.152126-20.407575 2.468173-40.90545 12.386013-59.702693 23.447642-44.50236 71.682361-67.031962 119.510735-55.39844 47.24143 11.498073 80.019969 53.441962 80.84771 103.437511 0.842791 50.793191 35.908905 91.247146 84.775717 97.823924a97.056382 97.056382 0 0 0 105.499339-67.588806c14.207044-46.669536-6.125283-96.604887-49.438706-117.25326zM284.246221 917.928767l-32.311994 104.099705h25.46432l6.019934-23.929237h30.776911l6.019934 23.929237h26.33721l-32.327045-104.099705z m3.928007 60.861531l2.227376-8.804153c2.663821-10.354286 5.46309-22.574752 7.976412-33.455782h0.571894c2.799269 10.640233 5.44804 23.101496 8.247309 33.455782l2.242425 8.804153zM450.456592 942.414848h24.772027v79.613624h-24.772027zM462.917855 905.753451c-8.382758 0-14.267243 5.312592-14.267243 12.867609s5.884485 12.73216 14.267243 12.73216 14.131794-5.312592 14.131794-12.73216-5.869435-12.867608-14.131794-12.867609zM639.422312 936.81631l0.978239 11.889369c-5.177143-5.026645-10.354286-8.247309-19.173489-8.247309-16.554818 0-32.883888 15.666878-32.883888 41.838539 0 25.885715 12.73216 41.688041 32.612991 41.688041 7.524917 0 15.245482-4.048405 20.844021-9.646944h0.632093l1.82103 7.690466h20.287177v-111.79017h-25.118174z m0 60.033789c-3.356113 5.177143-7.133621 6.712226-11.889369 6.712226-8.533256 0-13.544851-6.441329-13.544851-21.686811 0-14.688638 6.290831-21.069768 13.153555-21.069768a17.638406 17.638406 0 0 1 12.310765 4.755747zM782.350589 917.928767H757.307665v104.114755h65.481829v-20.994519h-40.438905v-83.120236zM964.920129 994.607674c-4.198904 5.869435-7.690465 8.111861-13.289003 8.11186-6.305881 0-9.240598-3.009967-9.240599-14.131794v-46.172892h-24.907475v49.258108c0 19.865781 7.419568 32.311994 24.772027 32.311994 10.91113 0 18.330698-5.026645 24.907476-12.867608h0.556844l1.82103 10.91113h20.287176v-79.613624h-24.907476zM1155.451032 942.414848h-25.735216l-4.906246 12.310764c-1.670532 4.51495-3.64206 9.029901-5.177143 13.544851h-0.692293c-2.242425-4.51495-4.51495-9.029901-6.576777-13.544851l-6.576778-12.310764h-26.728506l22.950998 38.19648-24.350632 41.417144h25.885715l5.46309-12.446213c1.956478-4.755748 3.912957-9.376047 5.869435-13.710399h0.707342c2.513322 4.334352 4.891196 9.029901 7.26907 13.710399l7.26907 12.446213h26.728506l-24.350632-38.617875z'
                        fill='#ffffff'
                        p-id='2645'></path>
                    <path d='M741.008694 715.177399m-98.576415 0a98.576415 98.576415 0 1 0 197.15283 0 98.576415 98.576415 0 1 0-197.15283 0Z' fill='#EE741B' p-id='2646'></path>
                </svg>
            </div>
            <Menu theme='dark' onOpenChange={subMenuOpenChange} openKeys={openKeys} onSelect={onSelectChange} selectedKeys={defaultRoute} mode='inline'>
                {routes.map(item => {
                    if (!item.children) {
                        return (
                            <Menu.Item key={item.key} icon={<item.icon />}>
                                <Link to={item.path}>{item.title}</Link>
                            </Menu.Item>
                        );
                    } else {
                        return (
                            <SubMenu key={item.key} icon={<item.icon />} title={item.title} className={item.menuSeparator ? 'menuSeparator':''}>
                                {item.children.map(item0 => (
                                    <Menu.Item key={item0.path} icon={<item0.icon />}>
                                        <Link to={item.path + '/' + item0.path}>{item0.title}</Link>
                                        {item0.path === 'report-info' && num !== 0 && <div className='redPoint'></div>}
                                    </Menu.Item>
                                ))}
                            </SubMenu>
                        );
                    }
                })}
            </Menu>
        </Sider>
    );
};

export default withRouter(SideBar);
